import { userRequest } from "../requestMethods";
import {
  getSubscriptionStart,
  getSubscriptionSuccess,
  getSubscriptionFailure,
} from "../redux/subsRedux";
import { toast } from "react-toastify";


export const getActiveSubscriptions = async (dispatch) => {
  dispatch(getSubscriptionStart());
  try {
    const res = await userRequest.get("comboApi/combosSubscription/getActiveSubscription");
    console.log(res.data, "res.data for categories");
    dispatch(getSubscriptionSuccess(res.data));
  } catch (err) {
    dispatch(getSubscriptionFailure());
  }
};

export const getSelectedSubscription = async (subsId) => {
  // dispatch(getSubscriptionStart());
  try {
    const res = await userRequest.get(`comboApi/combosSubscription/getSelectedSubscription/${subsId}`);
    // console.log(res.data, "res.data for categories");
    return res.data.data
    // dispatch(getSubscriptionSuccess(res.data));
  } catch (err) {
    console.log(err, 'err at sel subs')
    // dispatch(getSubscriptionFailure());
  }
};

